import React from 'react';
import styles from './styles.module.css';

import TEXT from '../../../data/text.json';

import ProfileIcon from '../../icons/Profile';
import ItemLink from '../item-link';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const dateFormat = timestamp => {
  const date = new Date(timestamp);
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

const paragraphs = text =>
  text.split('\n').map((part, index) => <p key={index}>{part}</p>);

export default ({
  submissionDate,
  name,
  personType,
  text,
  memoryDate,
  relatedItems,
}) => (
  <div className={styles.container}>
    <div className={styles.top}>
      <div className={styles.profileIcon}>
        <ProfileIcon size={64} color="#fff" />
      </div>
      <div className={styles.nameAndTime}>
        <div className={styles.name}>
          <span>{name}</span>
          {personType !== 'OTHER' &&
            TEXT.PERSON_TYPES[personType] && (
              <span className={styles.badge}>
                {TEXT.PERSON_TYPES[personType]}
              </span>
            )}
        </div>
        <div className={styles.date}>
          Submitted {dateFormat(submissionDate)}
        </div>
      </div>
    </div>

    <div className={styles.message}>
      {memoryDate && (
        <div className={styles.memoryDate}>Memory date: {memoryDate}</div>
      )}
      <div className={styles.text}>{paragraphs(text)}</div>

      {relatedItems.length > 0 && (
        <div className={styles.relatedItems}>
          <div>Related Items</div>
          <ul>
            {relatedItems.map(relatedItem => (
              <li key={relatedItem}>
                <ItemLink
                  id={relatedItem}
                  imageSizes="(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 4rem), (min-width: 768px) calc(33vw - 6rem), calc(50vw - 10rem)"
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/memory/index.js